function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly)
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    keys.push.apply(keys, symbols);
  }
  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

import React, {
  forwardRef,
  useCallback,
  useEffect,
  useImperativeHandle,
  useState,
  createRef
} from "react";
import { RadioGroupWrapper } from "./RadioGroup.style";

var RadioGroup = (_ref, ref) => {
  var { className, children, disabled, initialValue, selectedValue, onValueSelect } = _ref,
    props = _objectWithoutProperties(_ref, [
      "className",
      "children",
      "disabled",
      "initialValue",
      "selectedValue",
      "onValueSelect"
    ]);

  var [selected, setSelected] = useState(initialValue); // state is being controlled by the parent component

  useEffect(() => {
    if (typeof selectedValue !== "undefined") {
      setSelected(selectedValue);
    }
  }, [selectedValue]);
  var handleValueSelect = useCallback(
    newValue => {
      // state is being controlled internally
      if (selectedValue === undefined) {
        setSelected(newValue);
      }

      if (onValueSelect) {
        onValueSelect(newValue);
      }
    },
    [onValueSelect, selectedValue]
  );
  useImperativeHandle(ref || /*#__PURE__*/ createRef(), () => ({
    setSelectedValue: newValue => setSelected(newValue)
  }));
  return /*#__PURE__*/ React.createElement(
    RadioGroupWrapper,
    {
      className: className
    },
    React.Children.map(children, child => {
      var _child$props$disabled;

      return /*#__PURE__*/ React.cloneElement(
        child,
        _objectSpread(
          {
            disabled:
              (_child$props$disabled = child.props.disabled) !== null &&
              _child$props$disabled !== void 0
                ? _child$props$disabled
                : disabled,
            selectedValue: selected,
            onValueSelect: handleValueSelect
          },
          props
        )
      );
    })
  );
};

export default /*#__PURE__*/ forwardRef(RadioGroup);
